import { GetGroupsResponse } from "@performyard/service-contracts";

import request from "./internal-base-request";

export type GetGroupsParams = {
	hasEmployees?: boolean;
};

export const getGroupsInternalApi = async (params?: GetGroupsParams) => {
	const queryParams = new URLSearchParams();
	if (params?.hasEmployees) {
		queryParams.set("hasEmployees", "true");
	}
	const query = queryParams.toString();
	const url = query ? `/v1/groups?${query}` : `/v1/groups`;
	const [response] = await request<GetGroupsResponse>(url);

	return response.data;
};
